import { Typography } from "@mui/material";
import CustomTypography from "../ui/CustomTypography";

export default function PageHeaderComponent ({text}) {

    return(
        <CustomTypography text={text} variant={'subtitle1'}/>
    )
}